exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".category_item[data-v-5709b91d]{margin-bottom:10px}.header[data-v-5709b91d]{font-weight:700}.alert[data-v-5709b91d]{margin-bottom:8px;padding:.3em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5709b91d","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/AgeCategories/AgeCategories.vue
// module id = 713
// module chunks = 0 1